// Common
import { Directive, HostListener, Output, EventEmitter, Input } from '@angular/core';

// RX
import { timer } from 'rxjs';
import { first } from 'rxjs/operators';

@Directive({
  selector: '[appClick],[appDblClick]'
})
export class ClickDirective {

  // Outputs
  @Output() appClick = new EventEmitter<MouseEvent>();
  @Output() appDblClick = new EventEmitter<MouseEvent>();

  // Inputs
  @Input() stopPropagation = false;

  // Private
  private isSingleClick = true;

  /**
   * Constructor
   */

  constructor() { }

  /**
   * Actions
   */

  @HostListener('click', ['$event'])
  handleClick(event: MouseEvent) {
    if (this.stopPropagation) {
      event.stopPropagation();
    }

    this.isSingleClick = true;
    timer(200)
      .pipe(
        first(),
      )
      .subscribe(() => {
        if (this.isSingleClick) {
          this.appClick.emit(event);
        }
      });
  }

  @HostListener('dblclick', ['$event'])
  handleDblClick(event: MouseEvent) {
    if (this.stopPropagation) {
      event.stopPropagation();
    }

    this.isSingleClick = false;
    this.appDblClick.emit(event);
  }
}
